import React from 'react'
import { Card, Col } from 'react-bootstrap'
import styles from './AnalyticsPdfOverview.module.css'

const AnalyticsPdfStatsCard = ({ icon, value, label, alt }) => (
  <Col xs={6} md={3} className="mb-3">
    <Card className={styles.statsCard}>
      <div className="text-center">
        <div className={styles.statsIcon}>
          <img src={icon} alt={alt} width="24" height="24" />
        </div>
        <h3 className={styles.statsNumber}>{value}</h3>
        <p className={styles.statsLabel}>{label}</p>
      </div>
    </Card>
  </Col>
)

export default AnalyticsPdfStatsCard
